import { createJsonMemoryAccessors } from '@/services/storage'

import type {
  OptimizationHistoryEntry,
  OptimizationStrategy,
  OptimizationWeights,
} from '../types'
import { DEFAULT_OPTIMIZATION_WEIGHTS } from '../types'

const HISTORY_KEY = 'masterhub.purchase-optimizer.history.v1'
const WEIGHTS_KEY = 'masterhub.purchase-optimizer.weights.v1'

type Slot = 'history' | 'weights'

const memory: Record<Slot, unknown> = {
  history: null,
  weights: null,
}

const { readJson, writeJson } = createJsonMemoryAccessors(memory)

export function resetPurchaseOptimizerMemory(): void {
  memory.history = null
  memory.weights = null
}

export class OptimizationHistoryRepository {
  list(): OptimizationHistoryEntry[] {
    return readJson(HISTORY_KEY, 'history', [])
  }

  add(entry: Omit<OptimizationHistoryEntry, 'id' | 'createdAt'>): OptimizationHistoryEntry {
    const next: OptimizationHistoryEntry = {
      ...entry,
      id: crypto.randomUUID(),
      createdAt: new Date().toISOString(),
    }
    writeJson(HISTORY_KEY, 'history', [next, ...this.list()].slice(0, 100))
    return next
  }

  clear(): void {
    writeJson(HISTORY_KEY, 'history', [])
  }
}

export class OptimizationConfigRepository {
  getWeights(): OptimizationWeights {
    return readJson(WEIGHTS_KEY, 'weights', DEFAULT_OPTIMIZATION_WEIGHTS)
  }

  saveWeights(weights: OptimizationWeights): OptimizationWeights {
    writeJson(WEIGHTS_KEY, 'weights', weights)
    return weights
  }
}

export const optimizationHistoryRepository = new OptimizationHistoryRepository()
export const optimizationConfigRepository = new OptimizationConfigRepository()

export type { OptimizationStrategy }
